import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { DisconnectionComponent } from "./disconnection.component";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
  declarations: [DisconnectionComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatButtonModule,
    MatCardModule,
  ],
  exports: [DisconnectionComponent],
  providers: [],
})
export class DisconnectionModule {}
